// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import type {
    SsoUserCloseForgotPasswordEmailModalAction,
    SsoUserOpenForgotPasswordEmailModalAction
} from "../actions/modal/ssoUserSendForgotPasswordAction";
import type {SsoUserActionCollection} from "../actions/sso/ssoUserAction";
import type {
    SsoUserCloseResendActivationEmailModalAction,
    SsoUserOpenResendActivationEmailModalAction
} from "../actions/modal/ssoUserResendActivationEmailAction";
import type {SsoUserCloseActivateUserModalAction, SsoUserOpenActivateUserModalAction} from "../actions/modal/ssoUserActivateUserAction";
import type {
    PhotoEBadgeBulkDeleteSuccessAction,
    PhotoEBadgeCloseBulkDeletePhotoModalAction,
    PhotoEBadgeCloseDeletePhotoModalAction,
    PhotoEBadgeDeleteActionCollection, PhotoEBadgeOpenBulkDeletePhotoModalAction,
    PhotoEBadgeOpenDeletePhotoModalAction
} from "../actions/ebadge/photo/photoEBadgeAction";
import type {EBadgeButtonActionModalActionCollection, EBadgeButtonActionSuccessAction} from "../actions/ebadge/eBadgeButtonAction";

export type ModalState = {
    sendForgotPassword: {
        open: boolean,
        ssoUid?: string
    },
    resendActivation: {
        open: boolean,
        ssoUid?: string
    },
    activateUser: {
        open: boolean,
        ssoUid?: string
    },
    deletePhoto: {
        open: boolean,
        registrationCode?: string
    },
    bulkDeletePhoto: {
        open: boolean
    },
    [actionType: string]: {
        open: boolean,
        identifier?: string
    }
}

const INITIAL_STATE: ModalState = {
    sendForgotPassword: {
        open: false
    },
    resendActivation: {
        open: false
    },
    activateUser: {
        open: false
    },
    deletePhoto: {
        open: false
    },
    bulkDeletePhoto: {
        open: false
    }
};

type ModalActionCollection =
    SsoUserOpenForgotPasswordEmailModalAction | SsoUserCloseForgotPasswordEmailModalAction
    | SsoUserOpenResendActivationEmailModalAction | SsoUserCloseResendActivationEmailModalAction
    | SsoUserOpenActivateUserModalAction | SsoUserCloseActivateUserModalAction
    | SsoUserActionCollection | PhotoEBadgeDeleteActionCollection | PhotoEBadgeOpenDeletePhotoModalAction | PhotoEBadgeCloseDeletePhotoModalAction
    | PhotoEBadgeCloseBulkDeletePhotoModalAction | PhotoEBadgeOpenBulkDeletePhotoModalAction
    | PhotoEBadgeBulkDeleteSuccessAction | EBadgeButtonActionModalActionCollection | EBadgeButtonActionSuccessAction
;

export default function reducer(state: ModalState = INITIAL_STATE, action: ModalActionCollection) {

    switch (action.type) {
        case "sso/SHOW_FP_EMAIL_MODAL_ACTION":
            return {
                ...state,
                sendForgotPassword: {
                    open: true,
                    ssoUid: action.ssoUid
                }
            };
        case "sso/HIDE_FP_EMAIL_MODAL_ACTION":
        case "sso/SEND_FP_EMAIL_SUCCESS_ACTION":
            return {
                ...state,
                sendForgotPassword: {
                    open: false
                }
            };
        case "sso/SEND_FP_EMAIL_FAILED_ACTION":
            return {
                ...state,
                sendForgotPassword: {
                    open: true,
                    ssoUid: action.ssoUid
                }
            };
        case "sso/SHOW_RESEND_EMAIL_MODAL_ACTION":
            return {
                ...state,
                resendActivation: {
                    open: true,
                    ssoUid: action.ssoUid
                }
            };
        case "sso/HIDE_RESEND_EMAIL_MODAL_ACTION":
        case "sso/RESEND_EMAIL_SUCCESS_ACTION":
            return {
                ...state,
                resendActivation: {
                    open: false
                }
            };
        case "sso/RESEND_EMAIL_FAILED_ACTION":
            return {
                ...state,
                resendActivation: {
                    open: true,
                    ssoUid: action.ssoUid
                }
            };
        case "sso/SHOW_ACTIVATE_USER_MODAL_ACTION":
            return {
                ...state,
                activateUser: {
                    open: true,
                    ssoUid: action.ssoUid
                }
            };
        case "sso/HIDE_ACTIVATE_USER_MODAL_ACTION":
        case "sso/ACTIVATE_USER_SUCCESS_ACTION":
            return {
                ...state,
                activateUser: {
                    open: false
                }
            };
        case "sso/ACTIVATE_USER_FAILED_ACTION":
            return {
                ...state,
                activateUser: {
                    open: true,
                    ssoUid: action.ssoUid
                }
            };

        case "ebadge/photo/OPEN_DELETE_MODAL":
            return {
                ...state,
                deletePhoto: {
                    open: true,
                    registrationCode: action.registrationCode
                }
            };

        case "ebadge/photo/CLOSE_DELETE_MODAL":
        case "ebadge/photo/DELETE_SUCCESS_ACTION":
            return {
                ...state,
                deletePhoto: {
                    open: false,
                    registrationCode: undefined
                }
            };
        case "ebadge/photo/OPEN_BULK_DELETE_MODAL":
            return {
                ...state,
                bulkDeletePhoto: {
                    open: true,
                }
            };

        case "ebadge/photo/CLOSE_BULK_DELETE_MODAL":
        case "ebadge/photo/BULK_DELETE_SUCCESS_ACTION":
            return {
                ...state,
                bulkDeletePhoto: {
                    open: false,
                }
            };
        case "ebadge/SHOW_BUTTON_ACTION_MODAL":
            return {
                ...state,
                [action.actionType]: {
                    open: true,
                    identifier: action.registrationCode
                }
            };

        case "ebadge/HIDE_BUTTON_ACTION_MODAL":
        case "ebadge/BUTTON_ACTION_SUCCESS_ACTION":
            return {
                ...state,
                [action.actionType]: {
                    open: false
                }
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ModalReducer.js